import PropTypes from 'prop-types';
import React, { Component } from 'react';
import clsx from 'clsx';
import styles from './TopCities.module.css';
import { Context } from './LocaleWrapper';

class TopCities extends Component {
  static propTypes = {
    title: PropTypes.string,
    showMore: PropTypes.string,
    categoryId: PropTypes.number,
    cities: PropTypes.object,
    browseUriValues: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props);
    this.pageData = context.pageData;
    this.state = {
      showAll: false,
    };
  }

  renderCitiesList() {
    const { browseUriValues, showMore } = this.props;
    const { channel } = this.pageData;
    const cities = channel.topCities || [];
    const { generateUri } = this.context;
    const { showAll } = this.state;
    const showInitialCitiesCount = 4;

    const list = cities.map((city, index) => {
      const uri = generateUri('browse', {
        ...browseUriValues,
        location: city.normalisedName,
      });
      const className = clsx({
        [styles.item]: true,
        // Hide any items past the initial number to show.
        [styles.itemHidden]: !showAll && index >= showInitialCitiesCount,
      });

      return (
        <li key={city.normalisedName} className={className}>
          <a href={uri} className={styles.link}>
            {city.name}
          </a>
        </li>
      );
    });

    // Add a "show more" item if not currently showing all items.
    if (!showAll && list.length > showInitialCitiesCount) {
      list.push(
        <li
          key="showMore"
          className={styles.itemShowMore}
          onClick={() => this.setState({ showAll: true })}
        >
          <span className={styles.link}>{showMore}</span>
        </li>
      );
    }

    return list;
  }

  render() {
    const { title } = this.props;
    const { channel } = this.pageData;
    const cities = channel.topCities || [];

    if (cities.length === 0) {
      return null;
    }

    return (
      <div className={styles['top-cities']}>
        <div className={styles.title}>{title}</div>
        <ul className={styles.list}>{this.renderCitiesList()}</ul>
      </div>
    );
  }
}

TopCities.contextType = Context;

export default TopCities;
